export default '<!DOCTYPEhtml><html><head><title></title></head><body></body></html>';
